import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { bool, object, func, string } from 'prop-types'
import { debounce, result } from 'lodash'
import { Helmet } from 'react-helmet'
import queryString from 'query-string'

import Menu from '../../common/Menu'
import Arrow from './assets/dropdown-arrow.svg'
import logo from './assets/logo-beta.svg'
import searchIcon from './assets/search-icon.svg'
// import PopUp from '../../common/Modals/PopUp'
// import User from './assets/user.svg'
// import Inbox from './assets/inbox.svg'
// import Like from './assets/like.svg'
// import Logout from './assets/logout.svg'

import './AppHeader.scss'

import { togglePasarminaScroll } from '../../modules/Home'
import { getSearchType } from '../../modules/Main'
import { doLogout } from '../../modules/User'
import sortByProperty from '../../utils/sort'

class AppHeader extends Component {
  state = {
    search: '',
    hangingMode: false,
    onHoverCategories: false,
    onHoverProfileDropdown: false,
    showHoverSearch: false,
  }

  componentWillMount() {
    const { router: { history } } = this.context
    this.setState({
      search: result(queryString.parse(history.location.search), 'q', ''),
    })
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  onPasarminaClick = () => {
    this.props.togglePasarminaScroll(true)
  }

  handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    const status = scrollTop && scrollTop > 150
    this.setState({
      hangingMode: status,
    })
  }

  mouseEnterCategories = () => {
    this.setState({
      onHoverCategories: true,
    })
  }

  mouseLeaveCategories = () => {
    this.setState({
      onHoverCategories: false,
    })
  }

  mouseEnterProfileDropdown = () => {
    this.setState({
      onHoverProfileDropdown: true,
    })
  }

  mouseLeaveProfileDropdown = () => {
    this.setState({
      onHoverProfileDropdown: false,
    })
  }

  handleOnFieldFocus = (e) => {
    this.props.getSearchType(e.target.value)
    this.setState({
      showHoverSearch: true,
    })
  }

  handleOnFieldChange = (e) => {
    this.setState({
      search: e.target.value,
    })
    this.debounced(e.target.value)
  }

  handleOnFieldBlur = () => {
    setTimeout(() => {
      this.setState({
        showHoverSearch: false,
      })
    }, 500)
  }

  handleSearch = () => {
    const { router: { history } } = this.context
    const { search } = this.state
    history.push({ pathname: '/search', search: queryString.stringify({ q: search }) })
  }

  handleKeyPressSearch = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch()
      this.inputSearch.blur()
    }
  }

  debounced = debounce((content) => {
    this.props.getSearchType(content)
  }, 500)

  render() {
    const {
      isLoggedIn,
      // user,
      searchType,
      // notification,
    } = this.props
    const { showHoverSearch, search } = this.state
    // const notificationsLength = result(notification, 'data.length', 0)

    return (
      <div className={`app__fixed__top ${this.state.hangingMode ? 'hanging__mode' : ''}  visible-m visible-l`}>
        <div className='app__header'>
          <div className='container'>
            <div className='row'>
              <div className='rl-cl-l-6 rl-cl-m-6 clearfix'>
                <NavLink to='/' className='logo__minapoli'>
                  <img src={logo} alt='Logo Minapoli' />
                </NavLink>
                <div
                  className='hangging__menu'
                  onMouseEnter={this.mouseEnterCategories}
                  onMouseLeave={this.mouseLeaveCategories}>
                  <a>
                    <span>
                      <img className='arrow' src={Arrow} alt='kategori menu' />
                    </span>Kategori
                  </a>
                </div>
                <div className='search__box'>
                  <div className='search__wrap'>
                    <div className='search__left'>
                      <input
                        ref={(ref) => { this.inputSearch = ref }}
                        onKeyPress={this.handleKeyPressSearch}
                        onFocus={this.handleOnFieldFocus}
                        onChange={this.handleOnFieldChange}
                        onBlur={this.handleOnFieldBlur}
                        value={search || ''}
                        type='text'
                        id='search__input'
                        placeholder='Cari Produk / Info'
                        className='search__input' />
                      <ul
                        className={`search__result ${showHoverSearch ? 'animate' : ''}`}
                        onMouseEnter={this.mouseSearchResultEnter}
                        onMouseLeave={this.mouseSearchResultLeave}>
                        <li>
                          <span>Pasarmina</span>
                        </li>
                        {searchType &&
                          searchType.pasar &&
                          sortByProperty(searchType.pasar, 'name').map((item, index) => (
                            <li key={[`pasar-search-${index}`]}>
                              <NavLink to={`/p/${item.slug}`}>{item.name}</NavLink>
                            </li>
                          ))}
                        <li>
                          <div className='divider' />
                        </li>
                        <li>
                          <span>Eventmina</span>
                        </li>
                        {searchType &&
                          searchType.event &&
                          sortByProperty(searchType.event, 'name').map((item, index) => (
                            <li key={[`event-search-${index}`]}>
                              <NavLink to={`/e/${item.slug}`}>{item.name}</NavLink>
                            </li>
                          ))}
                        <li>
                          <div className='divider' />
                        </li>
                        <li>
                          <span>Infomina</span>
                        </li>
                        {searchType &&
                          searchType.info &&
                          sortByProperty(searchType.info, 'name').map((item, index) => (
                            <li key={[`info-search-${index}`]}>
                              <NavLink to={`/i/${item.slug}`}>{item.name}</NavLink>
                            </li>
                          ))}
                      </ul>
                    </div>
                    <div className='search__right'>
                      <button onClick={this.handleSearch} type='button'>
                        <img src={searchIcon} alt='search icon' />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='rl-cl-l-6 rl-cl-m-6'>
                <ul className='main__menu__header'>
                  <li>
                    <NavLink className='menu__link' to='/pasar'>
                      <span>pasar</span>mina
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className='menu__link' to='/event'>
                      <span>event</span>mina
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className={`menu__link ${isLoggedIn ? 'border-right' : ''}`} to='/info'>
                      <span>info</span>mina
                    </NavLink>
                  </li>
                  {/* Hide this for now */}
                  {
                    /* isLoggedIn ? (
                    <li>
                      <div
                        id='trigger__bottomsheet'
                        className='user__icon__header'
                        onMouseEnter={this.mouseEnterProfileDropdown}
                        onMouseLeave={this.mouseLeaveProfileDropdown}>
                        Hi, {user.name.substring(0, 10)}
                        <div className='user__image'>
                          <img className='rounded__image' src={user.profile_pic} alt='' />
                          {
                            notificationsLength > 0 &&
                            <div className='user__notification'>
                              <p>{notificationsLength}</p>
                            </div>
                          }
                        </div>
                        {this.state.onHoverProfileDropdown && (
                          <div className='hover__sheet'>
                            <span className='triangle' />
                            <ul>
                              <li>
                                <NavLink to={'/user/profile'}>
                                  <span className='icon-bottomsheet'>
                                    <img src={User} alt='' />
                                  </span>{' '}
                                  Profile
                                </NavLink>{' '}
                              </li>
                              <li>
                                <NavLink to={'/user/inbox'}>
                                  <span className='icon-bottomsheet'>
                                    <img src={Inbox} alt='' />
                                  </span>{' '}
                                  Inbox
                                </NavLink>{' '}
                              </li>
                              <li>
                                <NavLink to={'/user/favorite'}>
                                  <span className='icon-bottomsheet'>
                                    <img src={Like} alt='' />
                                  </span>{' '}
                                  Favorite
                                </NavLink>{' '}
                              </li>
                              <li>
                                <a
                                  onClick={() => {
                                    this.props.doLogout()
                                  }}>
                                  <span className='icon-bottomsheet'>
                                    <img src={Logout} alt='' />
                                  </span>{' '}
                                  Keluar
                                </a>{' '}
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </li>
                  ) : (
                    <li>
                      <PopUp buttonTitle='Masuk' customClass='special' />
                    </li>
                  ) */
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Menu
          onHoverMenu={this.state.onHoverCategories}
          mouseEnter={this.mouseEnterCategories}
          mouseLeave={this.mouseLeaveCategories} />
        {showHoverSearch && (
          <Helmet>
            <body className='overlay__body' />
          </Helmet>
        )}
      </div>
    )
  }
}

AppHeader.defaultProps = {
  user: {},
  searchTypeRequest: false,
  searchTypeError: '',
  searchType: null,
  notification: {},
}

AppHeader.propTypes = {
  isLoggedIn: bool.isRequired,
  user: object,
  doLogout: func.isRequired,
  getSearchType: func.isRequired,
  togglePasarminaScroll: func.isRequired,
  searchTypeRequest: bool,
  searchTypeError: string,
  searchType: object,
  notification: object,
}

AppHeader.contextTypes = {
  router: object,
}

const mapStateToProps = state => ({
  isLoggedIn: state.user.isLoggedIn,
  user: state.user.data,
  searchTypeRequest: state.main.searchTypeRequest,
  searchTypeError: state.main.searchTypeError,
  searchType: state.main.searchType,
  notification: state.notification,
})

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    doLogout,
    getSearchType,
    togglePasarminaScroll,
  },
  dispatch,
)

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader)



// WEBPACK FOOTER //
// ./src/common/AppHeader/AppHeader.js